import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const isoCountryCode = z
  .string()
  .regex(/^[A-Z]{2}$/, "Must be an ISO 3166-1 alpha-2 country code");

/** Address is what makes a MID derivable, so country is required. */
export const newManufacturerSchema = z.object({
  name: z.string().min(1).max(255),
  street1: z.string().max(255).nullable().optional(),
  street2: z.string().max(255).nullable().optional(),
  city: z.string().max(255).nullable().optional(),
  state: z.string().max(255).nullable().optional(),
  postalCode: z.string().max(32).nullable().optional(),
  country: isoCountryCode,
  /** Omit to derive from the name and address. */
  mid: z.string().max(50).nullable().optional(),
});

export const updateReturnProductCustoms = {
  name: "updateReturnProductCustoms" as const,
  input: z.object({
    /** Scopes the edit to a product actually on this return. */
    returnId: zExt.objectId(),
    /** Raw CockroachDB product.id; digits only so BigInt() cannot throw. */
    productId: z.string().regex(/^\d{1,20}$/),
    originCountry: isoCountryCode.nullable().optional(),
    hsCode: z.string().max(50).nullable().optional(),
    /** Both are concatenated into one carrier description field and truncated
     * to 250 (EasyPost) or 45 (Canada Post), so longer input can never ship. */
    customsDescription: z.string().max(250).nullable().optional(),
    materialDescription: z.string().max(250).nullable().optional(),
    manufacturerId: z
      .string()
      .regex(/^\d{1,20}$/)
      .nullable()
      .optional(),
    /** Creates and links a manufacturer; takes precedence over manufacturerId. */
    newManufacturer: newManufacturerSchema.optional(),
  }),
  output: z.object({ ok: z.literal(true) }),
};
